import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';

@Injectable()
export class WavestatusService {

  private hub: SignalRConnection;

  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService) { }

  StoresPie() {
    return {
      resize: { silent: false },
      title: {
        show: true,
        text: "Stores",
        textAlign: "center",
        textBaseline: "bottom",
        bottom: "-1%",
        left: "center",
        textStyle: {
          color: "#ccc",
          fontWeight: "lighter",
          fontSize: 14
        }
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: "horizontal",
        top: 0,
        left: 0,
        // x: 'left',
        data: [
          "OnHold",
          "Entered",
          "Committed",
          "Planned",
          "Released",
          "Picking",
          "Picked",
          "Loading",
          "Loaded",
          "Shipped"
        ],
        icon: "circle",
        textStyle: {
          color: "#999"
        }
      },
      //color:['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      series: [
        {
          name: "Stores",
          itemStyle: {
            normal: {
              label: {
                formatter: "{c} \n ({d}%)",
                position: "outside"
              },
              labelLine: {
                show: true
              }
            }
          },
          type: "pie",
          //selectedMode: 'single',
          radius: ["40%", "70%"],
          label: {
            normal: {
              position: "outside",
              offset: [-50, 50]
            },
            emphasis: {
              show: true,
              position: "center",
              textStyle: {
                fontSize: "18",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: [{}]
        }
      ]
    };
  }
  OrdersPie() {
    return {
      draggable: false,
      resizable: false,
      loading: false,
      style: {},
      title: {
        show: true,
        text: "Orders",
        textAlign: "center",
        textBaseline: "bottom",
        bottom: "-1%",
        left: "center",
        textStyle: {
          color: "#ccc",
          fontWeight: "lighter",
          fontSize: 14
        }
      },
      label: {
        normal: {
          show: true
        }
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: "horizontal",
        top: 0,
        left: 0,
        data: [
          "OnHold",
          "Entered",
          "Committed",
          "Planned",
          "Released",
          "Picking",
          "Picked",
          "Loading",
          "Loaded",
          "Shipped"
        ],
        icon: "circle",
        textStyle: {
          color: "#999999"
        }
      },
      //color:['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],

      series: [
        {
          name: "Orders",
          itemStyle: {
            normal: {
              label: {
                formatter: "{c} \n ({d}%)",
                position: "outside"
              },
              labelLine: {
                show: true
              }
            }
          },
          type: "pie",
          //selectedMode: 'single',
          radius: ["40%", "70%"],
          label: {
            normal: {
              position: "outside",
              testStyle: {
                fontSize: 5
              },
              offset: [-50, 50]
            },
            emphasis: {
              show: true,
              position: "center",
              textStyle: {
                fontSize: "18",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    };
  }
  QuantityPie() {
    return {
      draggable: false,
      resizable: false,
      loading: false,
      style: {},
      title: {
        show: true,
        text: "Quantity",
        textAlign: "center",
        textBaseline: "bottom",
        bottom: "-1%",
        left: "center",
        textStyle: {
          color: "#ccc",
          fontWeight: "lighter",
          fontSize: 14
        }
      },
      label: {
        normal: {
          show: true
        }
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: "horizontal",
        top: 0,
        left: 0,
        data: [
          "OnHold",
          "Entered",
          "Committed",
          "Planned",
          "Released",
          "Picking",
          "Picked",
          "Loading",
          "Loaded",
          "Shipped"
        ],
        icon: "circle",
        textStyle: {
          color: "#999999"
        }
      },
      //color:['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],

      series: [
        {
          name: "Quantity",
          itemStyle: {
            normal: {
              label: {
                formatter: "{c} \n ({d}%)",
                position: "outside"
              },
              labelLine: {
                show: true
              }
            }
          },
          type: "pie",
          //selectedMode: 'single',
          radius: ["40%", "70%"],
          label: {
            normal: {
              position: "outside",
              testStyle: {
                fontSize: 5
              },
              offset: [-50, 50]
            },
            emphasis: {
              show: true,
              position: "center",
              textStyle: {
                fontSize: "18",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log('Wave Order Status')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Wave Order Status';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor('broadcastWaveOrderStatus')
          .subscribe((result: any) => {
            console.log('broadcastWaveOrderStatus', result);
            if (
              result.widgetid == widget.widgetId &&
              result.widgetcreationtime == widget.widgetcreationtime
            ) {
              widget.dataLoaded = false;
              widget.OrdersPie = this.OrdersPie();
              widget.StoresPie = this.StoresPie();
              widget.QuantityPie = this.QuantityPie();
              widget.errorMessage = null;
              var Series1 = [];
              Series1.push({ value: result.OrdersReleased, name: "Released" });
              Series1.push({ value: result.OrdersPicking, name: "Picking" });
              Series1.push({ value: result.OrdersPicked, name: "Picked" });
              Series1.push({ value: result.OrdersLoading, name: "Loading" });
              Series1.push({ value: result.OrdersLoaded, name: "Loaded" });
              Series1.push({ value: result.OrdersShipped, name: "Shipped" });

              var Series2 = [];
              Series2.push({ value: result.OrdersReleased, name: "Released" });
              Series2.push({ value: result.StoresPicking, name: "Picking" });
              Series2.push({ value: result.StoresPicked, name: "Picked" });
              Series2.push({ value: result.StoresLoading, name: "Loading" });
              Series2.push({ value: result.StoresLoaded, name: "Loaded" });
              Series2.push({ value: result.StoresShipped, name: "Shipped" });

              var Series3 = [];
              Series3.push({ value: result.OrdersReleased, name: "Released" });
              Series3.push({ value: result.QuantityPicking, name: "Picking" });
              Series3.push({ value: result.QuantityPicked, name: "Picked" });
              Series3.push({ value: result.QuantityLoading, name: "Loading" });
              Series3.push({ value: result.QuantityLoaded, name: "Loaded" });
              Series3.push({ value: result.QuantityShipped, name: "Shipped" });

              //that.QuantityPie.series[0].visible = false ;//.data = Series3;
              widget.HideOrders = true;
              widget.HideStores = true;
              widget.HideQuantity = true;

              widget.OrdersPie.series[0].data = Series1;
              widget.StoresPie.series[0].data = Series2;
              widget.QuantityPie.series[0].data = Series3;

              widget.IfNoDataFound = result.IsNoDataFound;
              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.StoresPie.color = ["#fbb03b", "#8cc63f", "#44bd54", "#22b573", "#29abe2", "#0080a8"];
              widget.StoresPie.legend.data = ["OnHold", "Entered", "Committed", "Planned", "Released", "Picking", "Picked", "Loading", "Loaded", "Shipped"];
              widget.OrdersPie.color = ["#fbb03b", "#8cc63f", "#44bd54", "#22b573", "#29abe2", "#0080a8"];
              widget.OrdersPie.legend.data = ["OnHold", "Entered", "Committed", "Planned", "Released", "Picking", "Picked", "Loading", "Loaded", "Shipped"];
              widget.QuantityPie.color = ["#fbb03b", "#8cc63f", "#44bd54", "#22b573", "#29abe2", "#0080a8"];
              widget.QuantityPie.legend.data = ["OnHold", "Entered", "Committed", "Planned", "Released", "Picking", "Picked", "Loading", "Loaded", "Shipped"];

            }
            //console.log(result)  ;
            widget.dataLoaded = true;
            this._commonService.lastUpdatedTime = result.LastUpdateTime;
          }
            , err => {
              console.log('listenFor broadcastWaveOrderStatus error', err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEORDERSTATUS";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })

      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.OrdersPie = this.OrdersPie();
    widget.StoresPie = this.StoresPie();
    widget.QuantityPie = this.QuantityPie();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "WaveOrderStatus",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEORDERSTATUS";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "WaveOrderStatus",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) { }
          console.log('deleteWidget WaveOrderStatus RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/wavestatus.service.ts